<template>
  <div class="meter" @click="handleMeter" v-loading="loadingPage">
    <div class="title">{{ bigTitle }}</div>
    <div style="display: flex; min-height: 48px">
      <div class="tab">
        <div :class="tabidx !== 0? 'item':'item se'" @click="tab(0)">计费概况</div>
        <div :class="tabidx !== 1? 'item':'item se'" @click="tab(1)">账单管理</div>
        <div :class="tabidx !== 2? 'item':'item se'" @click="tab(2)">收据记录</div>
        <div :class="tabidx !== 3? 'item':'item se'" @click="tab(3)">租户管理</div>
      </div>
      <div style="margin-left: 12%" v-show="tabidx == 1">
        <TimePicker1 type="month" @sendTime="sendTime" :isHistory="true"/>
      </div>
    </div>
    <div class="account" v-show="tabidx == 2">
      <div class="account-top">
        <div style="font-size: 18rem; margin-left: 87rem">累计收入：<span class="price">¥{{
            INCOME_INFO.cumulativeRevenue
          }}</span></div>
        <div style="font-size: 18rem; margin-left: 130rem">本月收入：<span class="price">¥{{
            INCOME_INFO.monthRevenue
          }}</span></div>
        <div style="font-size: 18rem; margin-left: 130rem">本月退费：<span class="price">¥{{
            INCOME_INFO.monthRefund
          }}</span></div>
        <!--        <div style="font-size: 18rem">对公收款账户：<span>{{ INCOME_INFO.account }}</span></div>-->
        <el-button type="primary"
                   style="
                     width: 142rem;
                     height: 40rem;
                     text-align: center;
                     line-height: 40rem;
                     padding: 0;
                     font-size: 18rem;
                     margin-left: 125rem;
        ">
          <a href="https://pay.weixin.qq.com/index.php/core/home/login" target="_blank"
             style="text-decoration: none; color: #fff">查看钱款去向</a><br/>
        </el-button>
      </div>
      <div class="account-bottom">
        —— 所有钱款流向均直接通过对公收款账户，不会通过第三方，请妥善管理您的收款账户，注意查收钱款动态信息！ ——
      </div>
    </div>
    <div class="bill">
      <div style="display: flex; align-items: center">
        <div class="search">
          <el-input type="search" v-model.trim="searchValue" @input="search"
                    :placeholder="`输入${tabidx == 0 ? '房间名' : '租户名'}`"></el-input>
          <i class="el-icon-search" @click="search"></i>
        </div>
        <div class="search" style="margin-left: 25rem; width: 280rem" v-show="tabidx == 2">
          <el-date-picker
              v-model="dateValue"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="search"
          >
          </el-date-picker>
        </div>
        <div class="search" style="width: 120rem; margin-left: 10px" v-show="tabidx == 0">
          <div class="search-select" @click.stop="handleSelect(1)">
            <span>{{ selectItemValue.label }}</span><i class="el-icon-arrow-down"></i>
          </div>
          <div class="search-select-box" v-show="isShowSelectItem">
            <div class="search-select-item" v-for="item in statusOptions" :key="item.id"
                 @click.stop="handleSelect(2, item)">
              {{ item.label }}
            </div>
          </div>
        </div>
        <div v-show="tabidx == 0" style="margin-left: 15rem; font-size: 18rem; color: #666">在线/离线：{{
            STATUS_COUNT.ONLINE
          }}/{{
            STATUS_COUNT.LOST_CONTACT
          }}
        </div>
        <div v-show="tabidx == 0" style="margin-left: 30rem; font-size: 18rem; color: #666">
          欠费：{{ STATUS_COUNT.ARREARS_MONEY }}个
        </div>
        <el-button v-show="tabidx !== 0" style="margin-left: 10px" type="primary" size="small" @click="search">查询
        </el-button>
      </div>
      <div class="modify" v-show="tabidx == 1">
        <div class="price" @click="editEnergyPrice(editArr[0], 'price')">修改电价 | {{ list2Data.price }}￥</div>
        <div class="price" @click="editEnergyPrice(editArr[1], 'date')">修改结算日 | {{ list2Data.settlementDate }}日</div>
      </div>
      <div class="modify" v-show="tabidx !== 1">
        <div class="price" v-show="tabidx == 3" @click="handleEnter(1, '租户信息管理')">租户信息管理</div>
        <div class="price" v-show="tabidx == 0" @click="handleEnter(2, '房间表计录入')">房间表计录入 <img class="price-img"
                                                                                              src="@/assets/img/upload2.png"
                                                                                              alt=""></div>
      </div>
    </div>
    <div class="total" v-show="tabidx !== 2 && tabidx !== 3">
      <div class="income" v-show="tabidx == 0">
        总户数：<span>{{ STATUS_COUNT.TOTAL_COUNT }}</span> <span>户</span>
      </div>
      <div style="display: flex; align-items: flex-end" v-show="tabidx == 1">
        <div class="income">
          本月费用总计： <span><i>¥</i>{{ !!list2Data.totalCost ? Number(list2Data.totalCost).toFixed(2) : '--' }}</span>
        </div>
        <div class="income" style="padding-bottom: 5rem">
          计费周期： {{ list2Data.billingCycle }}
        </div>
      </div>
      <div v-show="tabidx !== 2" style="margin-right: 16rem;">
        <el-radio-group v-model="radio1" v-show="tabidx == 0">
          <el-radio label="BY_TENANT_NAME"><span style="font-size: 18rem">按用户名排序</span></el-radio>
          <el-radio label="BY_ROOM_NAME"><span style="font-size: 18rem">按房间名排序</span></el-radio>
        </el-radio-group>
        <el-radio-group v-model="radio2" v-show="tabidx == 1">
          <el-radio :label="0"><span style="font-size: 18rem">正常扣费靠前</span></el-radio>
          <el-radio :label="1"><span style="font-size: 18rem">先用后付靠前</span></el-radio>
        </el-radio-group>
      </div>
    </div>
    <Loading LoadingId="mulberryLoading" :scale="0.4" v-if="isRequest"/>
    <!--    计费概况、账单管理-->
    <div class="costDetail" :style="`overflow: auto`" v-show="tabidx !== 2 && tabidx !== 3 && !isRequest">
      <Card
          ref="cardRef"
          :list2Data.sync="list2Data"
          :currentTime="currentTime"
          :searchValue="searchValue"
          :tabidx="tabidx"
          :radio1="radio1"
          :radio2="radio2"
          :isRequest.sync="isRequest"
          :STATUS_COUNT.sync="STATUS_COUNT"
      />
    </div>
    <!--    收据记录-->
    <div class="costDetail" v-show="tabidx == 2 && !isRequest">
      <div class="nothing" v-if="tableData1.records && tableData1.records.length === 0">
        <img src="../../assets/img/not_found_data.png" alt="">
      </div>
      <el-table
          v-if="tableData1.records && tableData1.records.length !== 0"
          :data="tableData1.records"
          height="66%"
          :header-cell-style='{background: "#6cc9eb"}'
          style="width:100%; ">
        <el-table-column prop="roomName" label="房间号"/>
        <el-table-column prop="tenantName" label="用户名" width="150"/>
        <el-table-column prop="amount" label="售电金额(￥)" width="100"/>
        <el-table-column prop="businessType" label="业务类型"/>
        <el-table-column prop="payType" label="支付方式"/>
        <el-table-column prop="chargeState" label="状态" width="80"/>
        <el-table-column prop="tradeNo" label="订单号" width="180"/>
        <!--        <el-table-column prop="time" label="备注" width="100"/>-->
        <el-table-column prop="completeTime" label="时间" width="180"/>
        <el-table-column prop="operation" label="操作" width="105">
          <template slot-scope="scope">
            <a
                v-if="scope.row.businessType == '充值'"
                style="text-decoration: none; color: #0D94FF; font-size: 18rem"
                href="javascript:;"
                @click="preview(scope.row)">收据打印
            </a>
            <a href="javascript:;" style="text-decoration: none; color: #0D94FF; font-size: 18rem" v-else>--</a>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination" v-if="tableData1.records && tableData1.records.length !== 0">
        <div class="table-pagination-top">
          业务类型说明 :<br/>
          退费：退回用户账户剩余费用。<br/>
          冲正：由于网络等原因导致充值失败了，对租户充值金额进行退款。<br/>
          充值：租户对电表进行余额充值。<br/>
          销户：清账销户，该用户记录封存。<br/>
          注：退款金额均在3个工作日内原路返回租户充值时的账户。
        </div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData1.current"
            :page-sizes="[15, 30, 45, 60]"
            :page-size="tableData1.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData1.total">
        </el-pagination>
      </div>
    </div>
    <!--    租户管理-->
    <div class="costDetail" style="height: 85%; overflow: hidden" v-show="tabidx == 3 && !isRequest">
      <TableTenant
          ref="TableTenantRef"
          :tabidx="tabidx"
          :searchValue="searchValue"
          :isRequest.sync="isRequest"
      />
    </div>
    <DownLoadTable2 v-if="isLoad" @hidden="hidden" :tableDate="tableDate"/>
    <Edit v-if="isEditEnergy" @close="close" :editObj="editObj"/>
  </div>
</template>

<script>
import {getcurrentBill, gethistoryBill, getTypePrice, editPrice, settlementDate} from '../../api/power'
import {dayStart} from '../../util/DateUtil'
import DownLoadTable2 from './components/DownLoadTable2.vue'
import Edit from './components/Edit.vue'
import Card from './components/Card.vue'
import TableTenant from './components/tableTenant.vue'
import {
  PUT_V3_Cost_Tenant_Recharge_Page,
  GET_V3_Cost_Details,
  POST_V3_Cost_ElectricPrice,
  GET_V3_Cost_Room_Valid_Password
} from "../../api/billing";
import Loading from '../../components/common/Loading.vue'

const TimePicker1 = () => import('../../components/common/TimePicker1.vue')
export default {
  data() {
    return {
      tableDate: [], //下载表格数据
      tabidx: 0,
      isLoad: false, // 下载窗口开头
      selectDate: false, // 时间选择
      searchValue: '',
      scrollDx: 0,
      initialList: [], // 表格数组
      total: {
        realTimeTotal: 0,
        historyTotal: 0
      }, // 表格总计
      multipleSelection: [],
      monthArr: [],
      realTimeBill: [], // 实时账单
      historyBill: [], // 历史账单
      tableData1: {
        current: 1,
        size: 15
      },
      timer: null,
      currentTime: [],
      normalTime: [],
      isEditEnergy: false,
      editArr: [
        {
          name: '电价',
          num: 1,
          unit: '元'
        },
        {
          name: '结算日',
          num: 20,
          unit: '日'
        },
      ],
      editObj: {},
      dateRangeValue: [],
      statusValue: 0,
      statusOptions: [
        {
          id: 1,
          label: '全部',
          value: ''
        }, {
          id: 2,
          label: '欠费',
          value: 'ARREARS_MONEY'
        }, {
          id: 3,
          label: '离线',
          value: 'LOST_CONTACT'
        },
      ],
      radio1: 'BY_ROOM_NAME',
      radio2: 0,
      currentPage: 1,
      isShowSelectItem: false,
      selectItemValue: {
        id: 1,
        label: '全部',
        value: ''
      },
      list2Data: {},
      isRequest: true,
      // 电表状态数量
      STATUS_COUNT: {},
      // 获取收入基本信息
      INCOME_INFO: {},
      loadingPage: false,
      bigTitle: '计费概况',
      dateValue: ''
    }
  },
  components: {
    DownLoadTable2,
    Edit,
    TimePicker1,
    Card,
    Loading,
    TableTenant
  },
  computed: {},
  watch: {
    tabidx(idx) {
      if (idx == 2) {
        this.getData2()
      } else {
        return
      }
    }
  },
  mounted() {
    let cha = 0
    if (this.$store.getters.selProjectInfo.settlementDate > new Date().getDate()) {
      cha = 1
    }
    let time = dayStart(new Date()).split('-')
    this.normalTime = [time[0] + '年', time[1] - cha + '月']
    this.getBill()
  },
  methods: {
    handleMeter() {
      this.isShowSelectItem = false
    },

    // 下拉框切换
    async handleSelect(type, data) {
      switch (type) {
        case 1:
          this.isShowSelectItem = !this.isShowSelectItem;
          break
        case 2:
          this.selectItemValue = data;
          this.isShowSelectItem = false
          await this.$refs.cardRef.getInit('', data.value)
          break
        default:
          return
      }
    },

    handleSizeChange(val) {
      this.tableData1.size = val
      this.search()
    },

    handleCurrentChange(val) {
      this.tableData1.current = val
      this.search()
    },

    // 修改电价 、 结算日
    async close(editObj) {
      this.loadingPage = true
      this.isEditEnergy = false
      if (!editObj) {
        this.loadingPage = false
        return
      }
      if (editObj.name == '电价') {
        let res = await POST_V3_Cost_ElectricPrice({
          projectId: this.$store.getters.projectId,
          electricPrice: editObj.value
        })
        this.loadingPage = false
        if (res.data.code == 200) {
          // this.$message.success(res.data.msg);
          this.$message({
            type: 'success',
            duration: 5000,
            message: res.data.msg
          });
        } else {
          this.$message({
            type: 'error',
            duration: 5000,
            message: res.data.errMsg
          });
        }
      } else {
        let res = await settlementDate({
          projectId: this.$store.getters.projectId,
          settlementDate: editObj.value
        })
        this.loadingPage = false
        this.$message({
          type: 'success',
          duration: 5000,
          message: res.data.msg
        });
        if (res.data.code == 200) {
          // this.$message.success(res.data.msg);
          this.$message({
            type: 'success',
            duration: 5000,
            message: res.data.msg
          });
        } else {
          this.$message({
            type: 'error',
            duration: 5000,
            message: res.data.errMsg
          });
        }
      }
      this.loadingPage = false
    },
    // 修改电价
    editEnergyPrice(obj, type) {
      // console.log(obj)
      let _obj = {}
      if (type === 'price') {
        _obj = {...obj, num: this.list2Data.price}
      } else if (type === 'date') {
        _obj = {...obj, num: this.list2Data.settlementDate}
      }
      this.editObj = _obj
      this.isEditEnergy = true
    },
    // 关闭窗口
    hidden(off) {
      this.isLoad = off
    },

    // 获取收入基本信息
    async getINCOME_INFO() {
      const {data} = await GET_V3_Cost_Details()
      // console.log('获取收入基本信息', data)
      this.INCOME_INFO = data.data
    },

    // 获取收据记录数据
    getData2() {
      let _obj = {
        tenantName: this.searchValue,
        startDate: this.dateValue ? this.dateValue[0] : '',
        endDate: this.dateValue ? this.dateValue[1] : ''
      }
      if (!this.dateValue) {
        delete _obj.startDate
        delete _obj.endDate
      }
      PUT_V3_Cost_Tenant_Recharge_Page(
          this.tableData1.current,
          this.tableData1.size,
          {
            ..._obj
          },
      ).then((res) => {
        this.getINCOME_INFO()
        // console.log(res.data.data)
        this.tableData1 = res.data.data;
        // this.isRequest = false
      })
      setTimeout(() => {
        this.isRequest = false
      }, 500)
    },

    // 切换tab栏
    async tab(idx) {
      this.searchValue = ''
      this.radio1 = 'BY_TENANT_NAME'
      this.radio2 = 0
      this.selectItemValue = {
        id: 1,
        label: '全部',
        value: ''
      }
      this.isShowSelectItem = false
      this.tabidx = idx
      idx == 0 && (this.bigTitle = '计费概况')
      idx == 1 && (this.bigTitle = '账单管理')
      idx == 2 && (this.bigTitle = '收据记录')
      idx == 3 && (this.bigTitle = '租户管理')
    },

    // 搜索
    search() {
      this.isRequest = true
      // console.log(this.searchValue);
      this.$nextTick(async () => {
        switch (this.tabidx) {
          case 0:
            await this.$refs.cardRef.getInit()
            break
          case 1:
            await this.$refs.cardRef.getInit()
            break
          case 2:
            await this.getData2()
            break
          case 3:
            await this.$refs.TableTenantRef.getInit()
            break
          default:
            this.isRequest = false
            return
        }
      })
    },
    // 合并表格的第一列，处理表格数据
    flitterData(arr) {
      let spanOneArr = [];
      let concatOne = 0;
      arr.forEach((item, index) => {
        // console.log(item);
        if (index === 0) {
          spanOneArr.push(1);
        } else {
          //name 修改
          // item.itemCode 是我第一列要渲染的值  这个你们改成自己的
          if (item.company === arr[index - 1].company) {
            //第一列需合并相同内容的判断条件
            spanOneArr[concatOne] += 1;
            spanOneArr.push(0);
          } else {
            spanOneArr.push(1);
            concatOne = index;
          }
        }
      });
      return {
        one: spanOneArr,
      };
    },
    async getBill() {
      let res = await getcurrentBill({
        projectId: this.$store.getters.projectId
      })


      // console.log(res);
      if (res.data.code == 200) {
        let obj = res.data.data
        this.total.realTimeTotal = obj.cost ? Number(obj.cost).toFixed(2) : '--'
        let formatArr = []
        for (let key in obj) {
          for (let j in obj[key]) {
            if (obj[key][j] instanceof Object) {
              // console.log(obj[key][j]);
              let obj1 = {
                company: key,
                position: j,
                time: obj[key][j].start + '-' + obj[key][j].end,
                // time:new Date().getFullYear() + '.' + (new Date().getMonth() + 1) + '.01 - ' + obj[key][j].balanceTime.split('T')[0].replace(/-/g, '.'),
                start: obj[key][j].firstVal ? Number(obj[key][j].firstVal).toFixed(2) : '--',
                end: obj[key][j].lastVal ? Number(obj[key][j].lastVal).toFixed(2) : '--',
                dosage: obj[key][j].spreadVal ? Number(obj[key][j].spreadVal).toFixed(2) : '--',
                price: obj[key][j].price,
                payCost: obj[key][j].cost ? Number(obj[key][j].cost).toFixed(2) : '--',
                subtotal: obj[key].cost ? Number(obj[key][j].cost).toFixed(2) : '--',
                online: obj[key][j].heartState
              }
              formatArr.push(obj1)
            }
          }
        }

        // console.log(formatArr);
        this.realTimeBill = formatArr
        // this.tab(0)
      }
    },
    async gethistoryBill() {
      // console.log(this.currentTime);
      let lastday = new Date(parseInt(this.currentTime[0]), parseInt(this.currentTime[1]), 0).getDate()
      let cha = 0
      if (this.$store.getters.selProjectInfo.settlementDate > new Date().getDate()) {
        cha = 1
      }
      // console.log(lastday);
      let res = await gethistoryBill({
        date: `${parseInt(this.currentTime[0])}-${parseInt(this.currentTime[1])}-01T00:00:00Z`,
        projectId: this.$store.getters.projectId,
        // endDate:`${parseInt(this.currentTime[0])}-${parseInt(this.currentTime[1])}-${lastday}T00:00:00Z`
      })
      // console.log(res);
      if (res.data.code == 200) {
        let obj = res.data.data
        this.total.historyTotal = obj.cost ? Number(obj.cost).toFixed(2) : '--'
        let formatArr = []
        for (let key in obj) {
          // console.log(obj[key]);
          for (let j in obj[key]) {
            if (obj[key][j] instanceof Object) {
              // console.log(obj[key][j]);
              let obj1 = {
                company: key,
                position: j,
                time: obj[key][j].start.replace(/-/g, '.') + ' - ' + obj[key][j].end.replace(/-/g, '.'),
                start: obj[key][j].firstVal ? Number(obj[key][j].firstVal).toFixed(2) : '--',
                end: obj[key][j].lastVal ? Number(obj[key][j].lastVal).toFixed(2) : '--',
                dosage: obj[key][j].spreadVal ? Number(obj[key][j].spreadVal).toFixed(2) : '--',
                price: obj[key][j].price,
                payCost: obj[key][j].cost ? Number(obj[key][j].cost).toFixed(2) : '--',
                subtotal: obj[key].cost ? Number(obj[key][j].cost).toFixed(2) : '--',
              }
              formatArr.push(obj1)
            }
          }
        }
        // console.log(formatArr);
        this.historyBill = formatArr
        // this.tab(0)
      }
    },
    preview(row) {
      if (row) {
        this.tableDate = [row]
        this.isLoad = true
      } else {
        if (this.multipleSelection.length > 0) {
          this.tableDate = this.multipleSelection
          this.isLoad = true
        } else {
          this.$message({
            message: '请勾选缴费单位',
            type: 'warning'
          });
        }
      }
    },
    sendTime(time) {
      // console.log(time, "time", this.currentTime)
      this.currentTime = time.split('-')
      this.$refs.cardRef.getInit(time.split('-'))
    },
    // 房间表计录入 、租户信息管理
    handleEnter(type, title) {
      switch (type) {
        case 1:
          // 租户管理
          this.$refs.TableTenantRef.handleDialog('entering', type, title);
          break
        case 2:
          // 表计录入
          this.$refs.cardRef.handleDialog('entering', type, title);
          break
        default:
          return
      }
    }
  }

}
</script>

<style lang="less" scoped>
.nothing {
  width: 100%;
  height: 100%;
  position: relative;

  & > img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.meter {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding-left: 0.5vw;
  position: relative;

  .title {
    font-size: 18rem;
    font-weight: bold;
    height: 4.5vh;
    line-height: 50rem;
    //padding-left: 20rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }

  .account {
    //width: 100%;
    height: 104rem;
    min-height: 90rem;
    background-color: #f9f9f9;
    border-radius: 16rem;
    margin: 0 24rem 24rem 14rem;
    //margin-bottom: 24rem;
    padding: 15rem;
    font-size: 16rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .account-top {
      display: flex;
      justify-content: space-around;
      align-items: center;

      a {
        text-decoration: none;
      }

      span {
        font-weight: bold;
      }

      .price {
        color: #0d94ff;
      }
    }

    .account-bottom {
      text-align: center;
      font-size: 16rem;
      font-weight: 300;
      color: #999999;
    }
  }

  .tab {
    height: 3.5vh;
    display: flex;
    align-items: center;

    .item {
      height: 100%;
      line-height: 3.5vh;
      margin-right: 40rem;
      font-size: 16rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      position: relative;
      cursor: pointer;
      border-top: 2px solid transparent;

      //&::before {
      //  content: '';
      //  width: 100%;
      //  height: 2px;
      //  background: rgba(0, 0, 0, 0);
      //  position: absolute;
      //  left: 0;
      //  top: -10rem;
      //}
    }

    .se {
      box-sizing: border-box;
      color: #0D94FF;
      border-top: 2px solid #0D94FF;

      //&::before {
      //  background: #0D94FF;
      //}
    }
  }

  .bill {
    //height: 3.2vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .search {
      width: 240rem;
      height: 40rem;
      line-height: 40rem;
      background: #FFFFFF;
      border: 1px solid #CCCCCC;
      border-radius: 2px;
      position: relative;

      .search-select {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 12rem 0 14rem;
        font-size: 18rem;
        color: #666;
        cursor: pointer;
      }

      .search-select-box {
        width: calc(100% + 2px);
        position: absolute;
        top: 38rem;
        left: -1px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, .2);
        z-index: 999;

        .search-select-item {
          width: 100%;
          color: #666;
          padding: 0 12rem 0 14rem;
          font-size: 18rem;
          border: 1px solid #e5e5e5;
          border-top: none;
          cursor: pointer;
          background-color: #fff;

          &:hover {
            color: #0D94FF;
          }
        }
      }

      /deep/ .el-input__inner {
        width: 90% !important;
        height: 100%;
        border: none;
        padding: 1rem 0 0 0.5vw;

        &::placeholder {
          font-size: 12rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #CCCCCC;
        }
      }

      /deep/ input[type="search"]::-webkit-search-cancel-button {
        display: none;
      }

      & > i {
        position: absolute;
        right: 0.2vw;
        top: 11rem;
        color: #666;
        cursor: pointer;
      }
    }

    .monthBill {
      font-size: 24rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      position: relative;
      display: inline-block;
      // left: 50%;
      // top: 50%;
      // transform: translate(-50%, -50%);

    }

    .modify {
      display: flex;
      height: 40rem;
      line-height: 40rem;

      .price {
        padding: 0 8rem;
        //display: inline-block;
        background-color: #0D94FF;
        margin-right: 10rem;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 18rem;

        .price-img {
          width: 18rem;
          margin-left: 5rem;
        }
      }

    }

    .history {
      cursor: pointer;


    }

  }

  .total {
    //height: 7vh;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 22rem;

    .income {
      font-size: 18rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-right: 160rem;

      & > span > i {
        font-size: 18rem;
      }

      & > span:nth-child(1) {
        font-size: 30rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #0D94FF;
      }

      & > span:nth-child(2) {
        font-size: 18rem;
        color: #0D94FF;
      }
    }

  }

  .costDetail {
    width: 100%;
    height: 68vh;
    box-sizing: border-box;
    padding-top: 24rem;

    .table-pagination {
      height: 30%;
      padding: 15rem 12rem;
      position: relative;

      .table-pagination-top {
        font-size: 18rem;
        color: #999;
      }

      /deep/ .el-pagination {
        position: absolute;
        right: 12rem;
        bottom: 15rem;
      }
    }

    ///deep/ .el-table {
    //  height: 66% !important;
    //}

    /deep/ .el-table th > .cell {
      color: #fff;
      font-weight: 500;
      // padding-left: 20px;
      .el-checkbox {
        // display: none;
        position: fixed;
        // bottom: 3.3vh;
        top: 94.3%;
        left: 7.3vw;
        z-index: 999;
      }
    }

    /deep/ .el-table .el-table-column--selection {
      border-right: none;

      .cell {
        padding: 0 !important;
        text-align: right;
      }
    }

    /deep/ .el-table--border::after, .el-table--group::after, .el-table::before {
      display: none;
    }
  }

  .payText {
    font-size: 18rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }

  .onlineState {
    font-size: 16rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #68D86A;
  }

  .onlineNo {
    color: #FD4238;
  }
}

</style>